import { address } from './address';
import { image } from './image';
import { createMediaConverter } from './base-media';
import { pageUrl } from './page-url';
import { videoV2 } from './video-v2';
import { pageUrlV2 } from './page-url-v2';
import { video } from './video';
import { audio } from './audio';
export const veloConverters = [
    audio,
    address,
    createMediaConverter('document', 'wix.common.Document'),
    image,
    pageUrl,
    pageUrlV2,
    videoV2,
    video,
];
//# sourceMappingURL=converters.js.map